import {createFeature, createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {SystemUserRole} from './system-user-role.model';
import {SystemUserRoleActions} from './system-user-role.actions';

export const systemUserRolesFeatureKey = 'systemUserRoles';

export interface State extends EntityState<SystemUserRole> {
  // additional entities state properties
  loading: boolean;
}

export const adapter: EntityAdapter<SystemUserRole> = createEntityAdapter<SystemUserRole>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loading: false,
});

export const reducer = createReducer(
  initialState,
  on(SystemUserRoleActions.addSystemUserRole,
    (state, action) => adapter.addOne(action.systemUserRole, state)
  ),
  on(SystemUserRoleActions.upsertSystemUserRole,
    (state, action) => adapter.upsertOne(action.systemUserRole, state)
  ),
  on(SystemUserRoleActions.rolesLoadingState, ((state, action) => {
      return {...state, loading: action?.loading};
    })
  ),
  on(SystemUserRoleActions.addSystemUserRoles,
    (state, action) => adapter.addMany(action.systemUserRoles, state)
  ),
  on(SystemUserRoleActions.upsertSystemUserRoles,
    (state, action) => adapter.upsertMany(action.systemUserRoles, {...state, loading: false})
  ),
  on(SystemUserRoleActions.updateSystemUserRole,
    (state, action) => adapter.updateOne(action.systemUserRole, state)
  ),
  on(SystemUserRoleActions.updateSystemUserRoles,
    (state, action) => adapter.updateMany(action.systemUserRoles, state)
  ),
  on(SystemUserRoleActions.deleteSystemUserRole,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SystemUserRoleActions.deleteSystemUserRoles,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SystemUserRoleActions.loadSystemUserRoles,
    (state, action) => adapter.setAll(action.systemUserRoles, {...state, loading: false})
  ),
  on(SystemUserRoleActions.clearSystemUserRoles,
    state => adapter.removeAll(state)
  ),
);

export const systemUserRolesFeature = createFeature({
  name: systemUserRolesFeatureKey,
  reducer,
  extraSelectors: ({ selectSystemUserRolesState }) => ({
    ...adapter.getSelectors(selectSystemUserRolesState)
  }),
});

/*export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = systemUserRolesFeature;*/

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const getLoading = (state: State) => state.loading;
